import { render, staticRenderFns } from "./GoogleTrendChart.vue?vue&type=template&id=c23dee42&scoped=true"
import script from "./GoogleTrendChart.vue?vue&type=script&lang=js"
export * from "./GoogleTrendChart.vue?vue&type=script&lang=js"
import style0 from "./GoogleTrendChart.vue?vue&type=style&index=0&id=c23dee42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23dee42",
  null
  
)

export default component.exports